import { useQuery, useQueryClient } from "@tanstack/react-query";
import { EndpointsService } from "../services/endpoints/endpoints.service";
import { Document, IDocument, IDocumentApiResponse } from "../models/entities/document.model";

export const useDocuments = ({ participantId }: { participantId: number }) => {
	const queryClient = useQueryClient();
	const queryKey = ["documents", { participantId }];

	const query = useQuery({
		queryKey: queryKey,

		queryFn: async () => {
			const response = await EndpointsService.dataRetriever.getDocuments({
				participantId: participantId,
			});
			// Map API response to IDocument format
			return (response as IDocumentApiResponse[]).map((apiDoc) =>
				Document.fromApiResponse(apiDoc)
			);
		},

		enabled: !!participantId && participantId > 0,
	});

	return {
		...query,
		invalidate: () =>
			queryClient.invalidateQueries({
				queryKey: queryKey,
			}),
	};
};
